import { DataTableNew } from '@seapoint/client/src/design-system/data-table-new';
import { Inline } from '@seapoint/client/src/design-system/inline/inline';
import { Stack } from '@seapoint/client/src/design-system/stack/stack';
import { getCoreRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { PayrollRecordView } from '../../../../../types/entity-types';
import { NAME_COLUMN_ID, payrollSummaryTableColumnDefinition } from './payroll-summary-column-definition';

const PAGE_SIZE = 20;

export type PayrollSummaryTableProps = {
  records: PayrollRecordView[];
  onEditPayrollRecord?: (payrollRecordId: string) => void;
};

export const PayrollSummaryTable = ({ records, onEditPayrollRecord }: PayrollSummaryTableProps) => {
  const table = useReactTable({
    data: records,
    columns: payrollSummaryTableColumnDefinition,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      sorting: [
        {
          id: NAME_COLUMN_ID,
          desc: false,
        },
      ],
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
    meta: {
      onRowPrimaryAction: onEditPayrollRecord,
    },
  });

  return (
    <Stack space={5} align="stretch">
      <DataTableNew.Table table={table} aria-label="Payroll summary table" />
      {table.getPageCount() > 1 && (
        <Inline justify="end">
          <DataTableNew.Pagination table={table} />
        </Inline>
      )}
    </Stack>
  );
};
